import React from "react";
import { IconProps } from "../../utils/global-types/global-types";

const VerbamessengerColouredIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <g clipPath="url(#clip0_203_7356)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.2815 3.67828C12.8794 2.27439 11.0146 1.50086 9.02773 1.50015C4.9336 1.50015 1.60159 4.83181 1.60017 8.92702C1.59945 10.2362 1.9417 11.514 2.59165 12.6401L1.53784 16.4892L5.47528 15.4564C6.56007 16.0483 7.78161 16.3599 9.02454 16.3603H9.02773C13.1212 16.3603 16.4536 13.0283 16.455 8.93307C16.4557 6.94834 15.6839 5.08253 14.2815 3.67864V3.67828ZM9.02773 15.106H9.02525C7.91765 15.1056 6.8311 14.8079 5.88308 14.2456L5.65763 14.1117L3.32102 14.7246L3.94461 12.4463L3.79788 12.2127C3.17999 11.2298 2.85341 10.0937 2.85412 8.92739C2.85555 5.52378 5.62486 2.75446 9.03026 2.75446C10.6791 2.75518 12.2291 3.398 13.3947 4.56506C14.5603 5.73177 15.2017 7.28311 15.201 8.93236C15.1996 12.3363 12.4303 15.1056 9.02773 15.1056V15.106ZM12.4139 10.4826C12.2283 10.3897 11.3159 9.94093 11.1457 9.87898C10.9755 9.81699 10.8519 9.78604 10.7283 9.97192C10.6047 10.1578 10.2489 10.5759 10.1407 10.6995C10.0324 10.8234 9.92413 10.8388 9.73857 10.7458C9.55306 10.6528 8.95509 10.457 8.24603 9.82482C7.69439 9.33264 7.32183 8.7251 7.2136 8.53917C7.10533 8.35329 7.20221 8.25285 7.29478 8.16061C7.3781 8.07728 7.48033 7.94373 7.57327 7.83546C7.66625 7.72718 7.69687 7.64957 7.75882 7.52597C7.82081 7.40203 7.78982 7.2938 7.74353 7.20082C7.69721 7.10787 7.32614 6.19437 7.17121 5.82293C7.02055 5.4611 6.86744 5.51025 6.75382 5.5042C6.64555 5.49885 6.52199 5.49779 6.39805 5.49779C6.27411 5.49779 6.07323 5.54408 5.90301 5.72999C5.73279 5.91587 5.25341 6.36496 5.25341 7.27809C5.25341 8.19123 5.91834 9.07412 6.01128 9.19805C6.10422 9.32199 7.32005 11.1963 9.18158 12.0005C9.62429 12.1917 9.97008 12.306 10.2397 12.3915C10.6842 12.5329 11.0887 12.513 11.4085 12.4652C11.765 12.4118 12.5065 12.0161 12.661 11.5827C12.8156 11.1493 12.8156 10.7775 12.7693 10.7002C12.723 10.6229 12.5991 10.5763 12.4135 10.4833L12.4139 10.4826Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_203_7356">
          <rect
            width="14.9171"
            height="15"
            fill="white"
            transform="translate(1.53784 1.50015)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default VerbamessengerColouredIcon;
